import UIAlert from 'UIComponents/alert/UIAlert';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UIButton from 'UIComponents/button/UIButton';
import H5 from 'UIComponents/elements/headings/H5';
import UIFlex from 'UIComponents/layout/UIFlex';
import styled from 'styled-components';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import useLanguageFilterLogic from './hooks/useLanguageFilterLogic';
import { device } from '../../constants/StyledComponentConstants';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyledUIAlert = styled(UIAlert).withConfig({
  displayName: "LanguageFilterAlert__StyledUIAlert",
  componentId: "wa5mlj-0"
})(["&& > div{display:block;}@media screen and ", "{.dont-show-again-text{font-size:14px;}.sub-text{font-size:16px;}.text-box{margin-bottom:4px;}}"], device.mobile);
export const ResponsiveUIButton = styled(UIButton).withConfig({
  displayName: "LanguageFilterAlert__ResponsiveUIButton",
  componentId: "wa5mlj-1"
})(["@media screen and ", "{width:fit-content !important;overflow:visible !important;}"], device.mobile);
const LanguageFilterAlert = () => {
  const {
    filterLanguage,
    portalLanguage,
    alertDismissed,
    dontShowAgain,
    userAttributesError,
    userAttributesLoading,
    dontShowAgainChecked,
    setDontShowAgainChecked,
    handleDismissClick
  } = useLanguageFilterLogic();
  const {
    isMobile
  } = useMediaQuery();
  const isEnglishPortal = portalLanguage === 'en';
  if (isEnglishPortal && filterLanguage === 'en' || !isEnglishPortal && filterLanguage !== portalLanguage || alertDismissed || dontShowAgain || userAttributesError || userAttributesLoading) {
    return null;
  }
  return /*#__PURE__*/_jsx(StyledUIAlert, {
    className: isMobile ? 'm-top-3 m-bottom-2' : 'm-y-2',
    type: "info",
    children: /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      direction: isMobile ? 'column' : 'row',
      style: {
        width: '100%'
      },
      children: [/*#__PURE__*/_jsxs("div", {
        className: "text-box",
        children: [/*#__PURE__*/_jsx(H5, {
          style: {
            marginBottom: '4px'
          },
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: `learningCenter.languageFilterAlerts.languageFilterApplied.${isEnglishPortal ? 'englishPortal' : 'nonEnglishPortal'}.alertTitle`,
            options: {
              language: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `i18nAddon.languages.${filterLanguage}`
              })
            }
          })
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          className: "sub-text",
          message: `learningCenter.languageFilterAlerts.languageFilterApplied.${isEnglishPortal ? 'englishPortal' : 'nonEnglishPortal'}.alertSubtitle`
        })]
      }), /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        justify: "end",
        children: [/*#__PURE__*/_jsx(UICheckbox, {
          alignment: "center",
          checked: dontShowAgainChecked,
          className: "m-right-6",
          onChange: ({
            target: {
              checked
            }
          }) => setDontShowAgainChecked(checked),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            className: "dont-show-again-text",
            message: "learningCenter.languageFilterAlerts.dontShowAgain"
          })
        }), /*#__PURE__*/_jsx(ResponsiveUIButton, {
          onClick: handleDismissClick,
          size: "sm",
          use: "tertiary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.languageFilterAlerts.gotIt"
          })
        })]
      })]
    })
  });
};
export default LanguageFilterAlert;